export const FREE_TIER_LIMIT = 25;
